







































import { getGoodsTemplate,  goodsImportConfirm } from '@/utils/api';
import { Component, Vue} from 'vue-property-decorator';
@Component({
  components: {
  }
})
export default class DialogImport extends Vue {

  dialogFormVisible: boolean = true
  loading: boolean = false
  originalFileUrl: string = ''
  originalFilename: string = ''
  confirmLoading: boolean = false
  uploadUrl: string = process.env.NODE_ENV === 'development' ? `/bff-supplier/supplier/goodsManage/import/excel` :
      `${location.origin}/api/bff-supplier/supplier/goodsManage/import/excel`
  uploadHeaders: object = {} //上传请求头
  
  mounted() {
    let authToken = localStorage.getItem('authToken')
    if (authToken) {
      this.uploadHeaders["Authorization"] = `Bearer ${authToken}`;
    }
  }

  /**
    点击取消
    @params
   */
  onClickOut(): void {
    console.log(123)
    this.$emit('onClose')
  }

  /**
    点击确认
    @params
   */
  onConfirm(): void{
    this.confirmLoading = true
    const { originalFileUrl, originalFilename} = this
    goodsImportConfirm({originalFileUrl, originalFilename}).then((res: any) => {
      this.$message.success('导入中，请在列表中查看进度...')
      this.$emit('onConfirm')
      this.confirmLoading = false
    }).catch((error) => {
      console.error(error)
      this.$message.error(error)
      this.confirmLoading = false
    })
    
  }

  /**
    上传前校验
    @params file 文件对象
   */
  beforeUpload(file) {
    if(file.name.split('.')[0].length > 30) {
      this.$message.error('上传文件名称不能超过30个字!');
      return false
    }
    const whiteList: Array<string> = ['xlsx', 'xls']
    let idx: number = file.name.lastIndexOf('.');
    let suffix: string = (idx < 1) ? "" : file.name.substr(idx + 1);
    if(!whiteList.includes(suffix)) {
      this.$message.error('上传文件只能是xls和xlsx格式!');
      return false
    }
    return true
  }

  /**
    上传和导入成功
    @params response 接口响应
    @params file 文件对象
    @params fileList 文件列表
   */
  onSuccess(response, file, fileList) {
    if(file.status === 'success') {
      this.originalFileUrl = file.response.originalFileUrl
      this.originalFilename = file.response.originalFilename
      this.$message.success('文件上传成功！')
    }
  }

  /**
    上传和导入失败
    @params response 接口响应
    @params file 文件对象
    @params fileList 文件列表
   */
  onError(response, file, fileList) {
    if(file.status === 'fail') {
      this.$message.error('上传失败,请重新上传！')
    }
  }

  /**
    下载商品模板
    @params
   */
  download() {
    let a:HTMLAnchorElement = document.createElement('a')
    a.style.display = "none";
    a.href = location.origin + '/demo-import.xlsx';
    a.download = '商品导入模板'
    a.click();
    a.remove();
  }

  onExceed() {
    this.$message.warning('一次只能导入一个表格！')
  }
}
